module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.hide) ? _c('li', {
    class: [
      'service-item',
      _vm.service.is_emergency_nav ? "service-item--emergency" : ""
    ]
  }, [_c(_vm.service.is_url_target_blank ? 'a' : _vm.link, {
    tag: "component",
    staticClass: "h2 service-item__link fw-medium",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    }),
    attrs: {
      "tag": "h4",
      "to": {
        path: _vm.service.url
      },
      "href": _vm.service.url,
      "target": _vm.link === "a" ? '_blank' : "" || _vm.service.is_url_target_blank ? '_blank' : ""
    }
  }, [_c('div', {
    style: ([_vm.service.description ? {
      paddingTop: '0.5em',
      width: '100%'
    } : {}])
  }, [_c('span', {
    staticClass: "service-item__title"
  }, [_vm._v(_vm._s(_vm.service.label || _vm.service.name))]), _vm._v(" "), (_vm.service.description) ? _c('p', {
    staticClass: "small c-mid fsi",
    style: ({
      maxWidth: '90%',
      marginTop: '10px'
    })
  }, [_vm._v("\n        " + _vm._s(_vm.service.description) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "service-item__homesvg",
    style: ({
      'fill': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "7",
      "height": "12"
    }
  }, [_c('defs', [_c('path', {
    attrs: {
      "id": "a",
      "d": "M7.4 8l4.3 4.3a1 1 0 0 1-1.4 1.4l-5-5a1 1 0 0 1 0-1.4l5-5a1 1 0 0 1 1.4 1.4L7.4 8z"
    }
  })]), _c('use', {
    attrs: {
      "fill": "",
      "fill-rule": "evenodd",
      "transform": "rotate(180 6 7)",
      "xlink:href": "#a"
    }
  })])])])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-444660e1"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/ServiceItem.vue
// module id = 417
// module chunks = 0